<template>
    <div id="app">
        <div class="tw-bg-common-text-alert tw-mb-[64px] tw-flex tw-flex-col tw-gap-[10px]">
            <h1 class="tw-text-center">SELLSY UI LIBRARY</h1>

            <div class="container tw-flex-col" style="margin-top: 100px">
                <div class="tw-align-self-start typographies-heading-h1">
                    RichText: (Not a Compass component)
                </div>
                <!-- /!\ RichText is not a Compass component /!\ -->
                <RichText
                    v-model="editorContent"
                    :formitem="formItemRichText"
                    :placeholder="$t.__('pages.Compass2.enter_text')"
                    :options="optionsRichText"
                    class="custom-richtext"
                >
                    <!-- Example with custom option (like timetracking: see global usage on timeline/AnnotationCard.vue) -->
                    <template #more-custom-options>
                        <CompassIconButton
                            icon="performance"
                            size="small"
                            @click="handleLog('Custom button clicked')"
                        />
                    </template>
                    <!-- Example with custom actions -->
                    <template #actions>
                        <div class="tw-flex tw-gap-2">
                            <CompassButton
                                label="Annuler"
                                type="secondary"
                                size="small"
                                @click="handleLog('Annuler clicked')"
                            />
                            <CompassButton
                                label="Confirmer"
                                type="primary"
                                size="small"
                                @click="handleLog('Confirmer clicked')"
                            />
                        </div>
                    </template>
                </RichText>
                <!-- Basic example (with disabled) -->
                <RichText
                    v-model="editorContent"
                    :formitem="formItemRichText"
                    :placeholder="$t.__('pages.Compass2.enter_text')"
                    :options="optionsRichText"
                    class="custom-richtext"
                    :disabled="true"
                />
            </div>

            <!-- ***** -->
            <!-- ALERT -->
            <!-- ***** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassAlert :</div>
            <div class="container tw-flex-col">
                <CompassAlert
                    type="warning"
                    :description="neil"
                    :show-close="false"
                    :show-icon="false"
                    :action="{ label: 'clickme', callback: () => handleClick() }"
                />
                <br />
                <CompassAlert
                    type="informative"
                    description="Alert informative + close"
                    :show-close="true"
                    :show-icon="false"
                    :action="{ label: 'clickme', callback: () => handleClick() }"
                />
                <br />
                <CompassAlert
                    type="error"
                    description="Alert error + icon"
                    :show-close="false"
                    :show-icon="true"
                    :action="{ label: 'clickme', callback: () => handleClick() }"
                />
                <br />
                <CompassAlert
                    type="success"
                    description="Alert success + close + icon"
                    :show-close="true"
                    :show-icon="true"
                    :action="{ label: 'clickme', callback: () => handleClick() }"
                />
            </div>

            <!-- ****** -->
            <!-- AUTO COMPLETE -->
            <!-- ****** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassAutoComplete :</div>
            <div class="container">
                <!-- <CompassAutoComplete
                    placeholder="Rechercher"
                    size="medium"
                    no-results-label="Aucun résultat"
                    :results="results"
                    :has-more-results="hasMoreResults"
                    :loading="loading"
                    :dropdown-footer="[{ label: 'Footer action', callback: () => {} }]"
                    :error="false"
                    :disabled="false"
                    @update-search="handleAutoCompleteFetchResults"
                    @load-more-results="handleAutoCompleteFetchMoreResults"
                    @change="handleAutoCompleteChange"
                /> -->
            </div>

            <!-- ****** -->
            <!-- AVATAR -->
            <!-- ****** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassAvatar :</div>
            <div class="container">
                <CompassAvatar
                    photo="https://i-mom.unimedias.fr/2022/03/14/chat.jpg?auto=format%2Ccompress&crop=faces&cs=tinysrgb&fit=crop&h=591&w=1050"
                    initials="xx"
                    size="extra-large"
                />
                <CompassAvatar initials="xx" size="large" :border="true" />
                <CompassAvatar
                    initials="xx"
                    size="medium"
                    color-type="bg-component-background-avatar-random-pink"
                    state-badge="removed"
                />
                <CompassAvatar
                    initials="xx"
                    size="small"
                    color-type="bg-component-background-avatar-random-yellow"
                    state-badge="deactivated"
                />
                <CompassAvatar
                    initials="xx"
                    size="extra-small"
                    color-type="bg-component-background-avatar-random-green"
                    avatar-type="disabled"
                />
                <CompassAvatar size="extra-small" type="team" />
                <CompassAvatar size="large" type="company" />
            </div>

            <!-- ********** -->
            <!-- AVATARNAME -->
            <!-- ********** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassAvatarName :</div>
            <div class="container">
                <CompassAvatarName
                    firstname="Dave"
                    lastname="Chapelle"
                    caption="Comedian"
                    size="extra-large"
                >
                    <CompassAvatar
                        initials="DC"
                        photo="https://i-mom.unimedias.fr/2022/03/14/chat.jpg?auto=format%2Ccompress&crop=faces&cs=tinysrgb&fit=crop&h=591&w=1050"
                    />
                </CompassAvatarName>
                <CompassAvatarName
                    firstname="Dave"
                    lastname="Chapelle"
                    caption="Comedian"
                    size="large"
                >
                    <CompassAvatar initials="DC" />
                </CompassAvatarName>
                <CompassAvatarName
                    firstname="Dave"
                    lastname="Chapelle"
                    caption="Comedian"
                    :show-caption="false"
                >
                    <CompassAvatar
                        initials="DC"
                        avatar-color-type="bg-component-background-avatar-random-yellow"
                    />
                </CompassAvatarName>
                <CompassAvatarName
                    firstname="Dave"
                    lastname="Chapelle"
                    caption="Comedian"
                    size="small"
                >
                    <CompassAvatar
                        initials="DC"
                        avatar-color-type="bg-component-background-avatar-random-pink"
                        state-badge="deactivated"
                    />
                </CompassAvatarName>
                <CompassAvatarName
                    firstname="Dave"
                    lastname="Chapelle"
                    caption="Comedian"
                    size="extra-small"
                    :show-caption="false"
                >
                    <CompassAvatar initials="DC" state-badge="removed" />
                </CompassAvatarName>
            </div>
            <div class="container tw-flex-col">
                <p>Resize window to see ellipsis :</p>
                <div style="width: 20%">
                    <CompassAvatarName
                        size="extra-large"
                        firstname="Dave"
                        lastname="Chapelle"
                        caption="Comedian"
                    >
                        <CompassAvatar initials="DC" state-badge="removed" />
                    </CompassAvatarName>
                </div>
            </div>

            <!-- ****************** -->
            <!-- BACKFORWARD BUTTON -->
            <!-- ****************** -->
            <div class="tw-align-self-start typographies-heading-h1">
                CompassBackForwardButton :
            </div>
            <div class="container">
                <CompassBackForwardButton
                    link="https:go.sellsy.com"
                    forward
                    label="Placeholder"
                    size="small"
                    type="primary"
                    @click="handleClick"
                />
                <CompassBackForwardButton
                    link="https:go.sellsy.com"
                    forward
                    label="Placeholder"
                    size="medium"
                    type="secondary"
                    @click="handleClick"
                />
            </div>
            <div class="container">
                <CompassBackForwardButton
                    link="https:go.sellsy.com"
                    forward
                    label="Placeholder"
                    size="small"
                    type="primary"
                    disabled
                    @click="handleClick"
                />
                <CompassBackForwardButton
                    link="https:go.sellsy.com"
                    forward
                    label="Placeholder"
                    size="medium"
                    type="secondary"
                    disabled
                    @click="handleClick"
                />
            </div>

            <!-- ****** -->
            <!-- BANNER -->
            <!-- ****** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassBanner :</div>
            <div class="container">
                <CompassBanner
                    description="Lorem ipsum dolor sit, amet consectetur adipisicing elit. Libero ducimus ea similique expedita beatae tenetur quae minima tempora eligendi esse!"
                    type="informative"
                    :action="{ label: 'clickme', callback: () => handleClick() }"
                />
                <CompassBanner
                    description="Bonjour, je suis une bannière"
                    type="error"
                    :offset="{ x: 64, y: 101 }"
                />
            </div>

            <!-- ******* -->
            <!-- BUTTONS -->
            <!-- ******* -->
            <div class="tw-align-self-start typographies-heading-h1">CompassButton :</div>
            <div class="typographies-paragraph-medium-regular">Primary :</div>
            <div class="container">
                <CompassButton
                    label="Placeholder"
                    type="primary"
                    size="small"
                    @click="handleLog('clicked')"
                />
                <CompassButton
                    label="Placeholder"
                    type="primary-destructive"
                    size="medium"
                    @click="handleLog('clicked')"
                />
                <div class="tw-bg-sellsy-brand-primary-100 tw-p-[5px]">
                    <CompassButton
                        label="Placeholder"
                        type="primary-contrast"
                        size="large"
                        @click="handleLog('clicked')"
                    />
                </div>
            </div>
            <div class="typographies-paragraph-medium-regular">Secondary :</div>
            <div class="container">
                <CompassButton
                    label="Placeholder"
                    type="secondary"
                    size="small"
                    @click="handleLog('clicked')"
                />
                <CompassButton
                    label="Placeholder"
                    type="secondary-destructive"
                    size="medium"
                    @click="handleLog('clicked')"
                />
                <div class="tw-bg-sellsy-brand-primary-100 tw-p-[5px]">
                    <CompassButton
                        label="Placeholder"
                        type="secondary-contrast"
                        size="large"
                        @click="handleLog('clicked')"
                    />
                </div>
            </div>
            <div class="typographies-paragraph-medium-regular">Tertiary :</div>
            <div class="container">
                <CompassButton
                    label="Placeholder"
                    type="tertiary"
                    size="small"
                    @click="handleLog('clicked')"
                />
                <CompassButton
                    label="Placeholder"
                    type="tertiary-destructive"
                    size="medium"
                    @click="handleLog('clicked')"
                />
                <div class="tw-bg-sellsy-brand-primary-100 tw-p-[5px]">
                    <CompassButton
                        label="Placeholder"
                        type="tertiary-contrast"
                        size="large"
                        @click="handleLog('clicked')"
                    />
                </div>
            </div>

            <!-- ******** -->
            <!-- CHECKBOX -->
            <!-- ******** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassCheckbox :</div>
            <div class="container tw-flex-col">
                <div class="tw-flex tw-flex-col tw-items-start tw-gap-2">
                    <CompassCheckbox model-value="modelChecked1" />
                    <CompassCheckbox model-value="modelChecked2 checked" checked />
                    <CompassCheckbox
                        model-value="modelChecked3 small indeterminate"
                        size="small"
                        indeterminate
                    />
                    <CompassCheckbox
                        model-value="modelChecked4 large disabled"
                        size="large"
                        disabled
                    />
                    <CompassCheckbox model-value="modelChecked5 error" error />

                    <p>No label checkbox</p>
                    <CompassCheckbox
                        model-value="modelChecked5 checked"
                        size="small"
                        checked
                        error
                        :show-label="false"
                    />
                    <CompassCheckbox
                        model-value="modelChecked5 checked"
                        checked
                        error
                        :show-label="false"
                    />
                    <CompassCheckbox
                        model-value="modelChecked5 checked"
                        size="large"
                        checked
                        error
                        :show-label="false"
                    />
                </div>
            </div>

            <!-- ************* -->
            <!-- CHECKBOXGROUP -->
            <!-- ************* -->
            <div class="tw-align-self-start typographies-heading-h1">CompassCheckboxGroup :</div>
            <div class="container tw-flex-col">
                <div class="tw-flex tw-flex-col tw-items-start tw-gap-4">
                    <CompassCheckboxGroup
                        v-model="checkboxGroupModel"
                        label="CheckboxGroup horizontal medium"
                        direction="horizontal"
                        size="medium"
                    >
                        <CompassCheckbox model-value="small" size="small" />
                        <CompassCheckbox model-value="medium" size="medium" />
                        <CompassCheckbox model-value="large" size="large" />
                    </CompassCheckboxGroup>
                    <CompassCheckboxGroup
                        v-model="checkboxGroupModel2"
                        label="CheckboxGroup vertical small"
                        direction="vertical"
                        size="small"
                    >
                        <CompassCheckbox model-value="MyValue" size="small" indeterminate />
                        <CompassCheckbox model-value="MyValue2" size="medium" disabled />
                        <CompassCheckbox model-value="MyValue3" size="large" error />
                    </CompassCheckboxGroup>
                    <CompassCheckboxGroup
                        label="CheckboxGroup horizontal large"
                        direction="horizontal"
                        size="large"
                    >
                        <CompassCheckbox model-value="MyValue small checked" size="small" checked />
                        <CompassCheckbox
                            model-value="MyValue2 medium checked"
                            size="medium"
                            checked
                        />
                        <CompassCheckbox
                            model-value="MyValue3 large checked"
                            size="large"
                            checked
                        />
                    </CompassCheckboxGroup>
                </div>
            </div>

            <!-- ****** -->
            <!-- DIALOG -->
            <!-- ****** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassDialog :</div>
            <div class="container">
                <CompassButton label="Dialog 1" @click="openModalOne = true"
                    >Open Dialog 1 (overflowed text + bodyScroll allowed)</CompassButton
                >
                <CompassButton label="Dialog 2" @click="openModalTwo = true"
                    >Open Dialog 2 (bodyScroll not allowed + custom cancel handler)</CompassButton
                >
                <CompassButton label="Dialog 3" @click="openModalThree = true"
                    >Open Dialog 3 (bodyScroll not allowed + can not close on click on
                    overlay)</CompassButton
                >
                <!-- With default header -->
                <CompassDialog
                    :visible.sync="openModalOne"
                    title="LongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWordLongWord Titre de la modal One"
                    :primary-action="{
                        label: 'primaryAction',
                        action: () => handleLog('primaryAction clicked'),
                    }"
                    :secondary-actions="[
                        {
                            label: 'secondaryAction1',
                            action: () => handleLog('secondaryAction1 clicked'),
                        },
                        {
                            label: 'secondaryAction2',
                            action: () => handleLog('secondaryAction2 clicked'),
                        },
                    ]"
                    body-scroll
                    @opened="handleLog('opened')"
                    @closed="handleLog('closed')"
                >
                    <p v-for="(_, index) in 70" :key="`modal-content-${index}`" style="margin: 0px">
                        Modal Content
                    </p>
                </CompassDialog>
                <!-- With custom header -->
                <CompassDialog :visible.sync="openModalTwo">
                    <template #header>
                        <div class="tw-flex tw-items-center tw-justify-center tw-p-[10px]">
                            <div class="typographies-heading-h2">Custom Header</div>
                        </div>
                    </template>

                    <p>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta quisquam
                        provident voluptate consequuntur similique praesentium ex beatae est nisi
                        earum?
                    </p>

                    <template #footer>
                        <div
                            class="tw-flex tw-items-center tw-justify-center tw-gap-[5px] tw-p-[10px]"
                        >
                            <CompassButton label="Annuler" @click="handleLog('Annuler clicked')" />
                            <CompassButton
                                label="Confirmer"
                                @click="handleLog('Confirmer clicked')"
                            />
                        </div>
                    </template>
                </CompassDialog>
                <!-- With prop which disable close on click outside -->
                <CompassDialog
                    :visible.sync="openModalThree"
                    :close-on-click-overlay="false"
                    title="Titre de la modal Three"
                    :primary-action="{
                        label: 'primaryAction',
                        action: () => handleLog('primaryAction clicked'),
                    }"
                    :secondary-actions="[
                        {
                            label: 'secondaryAction1',
                            action: () => handleLog('secondaryAction1 clicked'),
                        },
                        {
                            label: 'secondaryAction2',
                            action: () => handleLog('secondaryAction2 clicked'),
                        },
                    ]"
                    @opened="handleLog('opened')"
                    @closed="handleLog('closed')"
                ></CompassDialog>
            </div>

            <!-- ************* -->
            <!-- FEATURE BADGE -->
            <!-- ************* -->
            <div class="tw-align-self-start typographies-heading-h1">CompassFeatureBadge :</div>
            <div class="container">
                <CompassFeatureBadge />
                <CompassFeatureBadge size="small" />
                <CompassFeatureBadge variant="upsell" />
                <CompassFeatureBadge size="small" variant="upsell" />
            </div>

            <!-- ************* -->
            <!-- FEATURE MODAL -->
            <!-- ************* -->
            <div class="tw-align-self-start typographies-heading-h1">CompassFeatureModal :</div>
            <CompassButton label="Open Feature Modal" @click="openFeatureModal = true" />
            <CompassFeatureModal
                :visible.sync="openFeatureModal"
                title="Titre de la modal Three"
                :primary-action="{
                    label: 'primaryAction',
                    action: () => handleLog('primaryAction clicked'),
                }"
                @opened="handleLog('opened')"
                @closed="handleLog('closed')"
            >
                <template #header>
                    <img
                        src="/ressources/logged/img/illustrations/modal-services-upgrade-plan.svg"
                    />
                </template>
                <template>Content here ? </template>
            </CompassFeatureModal>

            <!-- **** -->
            <!-- FLAG -->
            <!-- **** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassFlag :</div>
            <div class="container tw-flex-col">
                <CompassFlag label="New" size="small" />
                <CompassFlag label="New" />
                <CompassFlag label="New" size="large" />
                <CompassFlag label="Beta" :beta="true" size="small" />
                <CompassFlag label="Beta" :beta="true" />
                <CompassFlag label="Beta" :beta="true" size="large" />
            </div>

            <!-- ********* -->
            <!-- FORM ITEM -->
            <!-- ********* -->
            <div class="tw-align-self-start typographies-heading-h1">CompassFormItem :</div>
            <div class="container tw-flex-col">
                <CompassFormItem
                    label="Label"
                    info="Long caption text for input"
                    error="Long warn text for input"
                    size="small"
                    :disabled="isDisabled"
                    required
                >
                    <CompassInput
                        v-model="inputModel3"
                        size="small"
                        suffix-icon="heart"
                        placeholder="Placeholder"
                        :error="hasError"
                        :disabled="isDisabled"
                        @keypress="handleLog('keypress')"
                        @input="handleLog('input')"
                    />
                </CompassFormItem>
            </div>

            <!-- ***** -->
            <!-- ICONS -->
            <!-- ***** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassIcon :</div>
            <div class="container">
                <CompassIcon icon="dashboard-fill" size="large" />
                <CompassIcon icon="heart" size="large" type="secondary" />
                <CompassIcon icon="accounting-fill" size="large" type="alert" />
                <CompassIcon icon="richeditor-text-height" size="large" />
                <CompassIcon icon="richeditor-link" size="large" />
            </div>

            <!-- ****** -->
            <!-- INPUTS -->
            <!-- ****** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassInput :</div>
            <div class="container tw-flex-col">
                <CompassInput
                    ref="input1"
                    v-model="inputModel"
                    placeholder="Mon icône est en slot"
                    :error="hasError"
                    :disabled="isDisabled"
                    size="large"
                    @input="handleInput($event)"
                    @blur="handleBlur($event)"
                    @focus="handleFocus($event)"
                    @change="handleChange($event)"
                >
                    <template #prefix>
                        <CompassIcon icon="flash" size="extra-small" />
                    </template>
                </CompassInput>
                <CompassInput
                    ref="input1"
                    v-model="inputModel"
                    placeholder="Mon icône est en slot"
                    :error="hasError"
                    :disabled="isDisabled"
                    size="large"
                    @input="handleInput($event)"
                    @blur="handleBlur($event)"
                    @focus="handleFocus($event)"
                    @change="handleChange($event)"
                >
                    <template #prefix>
                        <p>I'm a slot</p>
                    </template>
                </CompassInput>
                <CompassInput
                    v-model="inputModel2"
                    suffix-icon="dashboard-fill"
                    prefix-icon="heart"
                    placeholder="Placeholder"
                    :error="hasError"
                    :disabled="isDisabled"
                    size="medium"
                    @input="handleInput($event)"
                    @blur="handleBlur($event)"
                    @focus="handleFocus($event)"
                    @change="handleChange($event)"
                />
                <CompassInput
                    v-model="inputModel3"
                    suffix-icon="dashboard-fill"
                    prefix-icon="heart"
                    placeholder="Placeholder"
                    :error="hasError"
                    :disabled="isDisabled"
                    size="small"
                    @input="handleInput($event)"
                    @blur="handleBlur($event)"
                    @focus="handleFocus($event)"
                    @change="handleChange($event)"
                />
                <CompassInput
                    v-model="inputModel4"
                    placeholder="Placeholder"
                    type="textarea"
                    :error="hasError"
                    :disabled="isDisabled"
                    size="medium"
                    @input="handleInput($event)"
                    @blur="handleBlur($event)"
                    @focus="handleFocus($event)"
                    @change="handleChange($event)"
                />
                <div>{{ inputModel }}</div>
                <div class="tw-flex tw-gap-[5px]">
                    <CompassButton
                        label="Focus input 1"
                        type="secondary-destructive"
                        size="large"
                        @click="$refs.input1.setFocus()"
                    />
                    <CompassButton
                        label="Trigger une error"
                        type="primary-destructive"
                        size="large"
                        @click="setError"
                    />
                    <CompassButton
                        label="Trigger disabled"
                        type="secondary-destructive"
                        size="large"
                        @click="setDisabled"
                    />
                </div>
            </div>

            <!-- **** -->
            <!-- LINK -->
            <!-- **** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassLink :</div>
            <div class="container">
                <CompassLink
                    link="https://google.com"
                    target="_blank"
                    label="Placeholder"
                    suffix-icon="heart"
                    type="primary"
                    size="small"
                />
                <CompassLink
                    label="Placeholder"
                    type="secondary"
                    size="medium"
                    @click="handleClick"
                >
                    <template #suffix>
                        <CompassIcon icon="heart" size="medium" />
                    </template>
                </CompassLink>
            </div>

            <!-- ****** -->
            <!-- LOADER -->
            <!-- ****** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassLoader :</div>
            <div class="container">
                <CompassLoader size="extra-small" />
                <CompassLoader size="small" />
                <CompassLoader />
                <CompassLoader size="large" color="sellsy-brand-primary-100" />
            </div>

            <!-- **** -->
            <!-- LOGO -->
            <!-- **** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassLogo :</div>
            <div class="container tw-flex-col">
                <CompassLogo type="icon" :width="30" />
                <CompassLogo type="logo" :width="140" />
            </div>
            <div class="black container tw-flex-col">
                <CompassLogo type="icon" theme="light" :width="24" />
                <CompassLogo type="logo" theme="light" :width="100" />
            </div>

            <!-- **** -->
            <!-- MENU -->
            <!-- **** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassMenu :</div>
            <div class="container tw-flex-col">
                <CompassMenu
                    trigger="hover"
                    @visible-change="handleVisibleChange"
                    @open="handleOpen"
                    @close="handleClose"
                >
                    <CompassButton label="Actions" />
                    <template #dropdown>
                        <CompassMenuItem label="item1" @click="handleLog('click on item 1')" />
                        <CompassMenuItem
                            label="item 2"
                            disabled
                            @click="handleLog('click on item 2')"
                        />
                        <CompassMenuItem label="item 3" @click="handleLog('click on item 3')" />
                        <CompassMenuGroup label="SubMenu">
                            <template #dropdown>
                                <CompassMenuItem
                                    label="sub-item 1"
                                    @click="handleLog('click on sub-item 1')"
                                />
                                <CompassMenuItem
                                    label="sub-item 2"
                                    @click="handleLog('click on sub-item 2')"
                                />
                                <CompassMenuItem
                                    label="sub-item 3"
                                    disabled
                                    @click="handleLog('click on sub-item 3')"
                                />
                                <CompassMenuItem
                                    label="sub-item 4"
                                    @click="handleLog('click on sub-item 4')"
                                />
                            </template>
                        </CompassMenuGroup>
                    </template>
                </CompassMenu>
                <CompassMenu trigger="click" placement="left-start" custom-class="context-menu">
                    <CompassIconButton icon="action" />
                    <template #dropdown>
                        <CompassMenuItem label="Voir l'opportunité" />
                        <CompassMenuItem label="Voir dans un nouvel onglet" />
                        <CompassMenuItem label="Modifier" />
                        <CompassMenuGroup label="Changer l'étape" placement="left-start">
                            <template #dropdown>
                                <CompassMenuItem label="Piste - 0%" />
                                <CompassMenuItem label="Prospection - 10%" />
                                <CompassMenuItem label="Contact téléphonique - 20%" />
                                <CompassMenuItem label="Envoie de devis - 30%" />
                                <CompassMenuItem label="Negociation - 40%" />
                                <CompassMenuItem label="Devis signé - 70%" />
                                <CompassMenuItem
                                    label="Super long text Super long text Super long text Super long text Super long text Super long text "
                                />
                                <CompassMenuItem label="Affaire conclue - 100%" />
                                <CompassMenuItem label="Affaire conclue - 100%" />
                                <CompassMenuItem label="Affaire conclue - 100%" />
                                <CompassMenuItem label="Affaire conclue - 100%" />
                                <CompassMenuItem label="Affaire conclue - 100%" />
                                <CompassMenuItem label="Affaire conclue - 100%" />
                            </template>
                        </CompassMenuGroup>
                        <CompassMenuGroup label="Changer le statut" placement="left-start">
                            <template #dropdown>
                                <CompassMenuItem label="Annulée" />
                                <CompassMenuItem label="Fermée" />
                                <CompassMenuItem label="En retard" />
                                <CompassMenuItem label="Perdue" />
                                <CompassMenuItem label="Ouverte" />
                                <CompassMenuItem label="Gagnée" />
                            </template>
                        </CompassMenuGroup>
                        <CompassMenuItem label="Supprimer" />
                    </template>
                </CompassMenu>
            </div>

            <!-- ************ -->
            <!-- MULTI AVATAR -->
            <!-- ************ -->
            <div class="tw-align-self-start typographies-heading-h1">CompassMultiAvatar :</div>
            <div class="container">
                <CompassMultiAvatar
                    size="extra-large"
                    :avatars="[
                        {
                            photo: 'https://i-mom.unimedias.fr/2022/03/14/chat.jpg?auto=format%2Ccompress&crop=faces&cs=tinysrgb&fit=crop&h=591&w=1050',
                            initials: 'HS',
                            fullname: 'Homer Simpson',
                            avatarColorType: 'bg-component-background-avatar-random-pink',
                        },
                        {
                            initials: 'TS',
                            fullname: 'Thibaut Super Schmutz',
                            avatarColorType: 'bg-component-background-avatar-random-green',
                        },
                        {
                            initials: 'CJ',
                            fullname: 'Cévric Julia',
                            avatarColorType: 'bg-component-background-avatar-random-yellow',
                            stateBadge: 'deactivated',
                        },
                        {
                            initials: 'VK',
                            fullname: 'Vincent Kraus',
                            avatarColorType: 'bg-component-background-avatar-random-pink',
                            stateBadge: 'removed',
                        },
                        {
                            initials: 'SP',
                            fullname: 'Sébastien Portrait',
                            avatarColorType: 'bg-component-background-avatar-random-pink',
                        },
                        {
                            initials: 'MY',
                            fullname: 'Magalie Yang',
                            avatarColorType: 'bg-component-background-avatar-random-green',
                        },
                        {
                            initials: 'TF',
                            fullname: 'Thomas Feuillatre',
                            avatarColorType: 'bg-component-background-avatar-random-pink',
                        },
                        {
                            initials: 'NA',
                            fullname: 'Neil Appleton',
                            avatarColorType: 'bg-component-background-avatar-random-yellow',
                        },
                    ]"
                />
                <CompassMultiAvatar
                    :avatars="[
                        {
                            initials: 'mj',
                            fullname: 'Michael Jordan',
                            avatarColorType: 'bg-component-background-avatar-random-pink',
                        },
                        {
                            initials: 'km',
                            fullname: 'Karl Malone',
                            avatarColorType: 'bg-component-background-avatar-random-green',
                        },
                    ]"
                />
                <CompassMultiAvatar
                    size="small"
                    :avatars="[
                        {
                            photo: 'https://i.pravatar.cc/300',
                            initials: 'xx',
                            fullname: 'Michael Jordan',
                            avatarColorType: 'bg-component-background-avatar-random-pink',
                        },
                        {
                            photo: 'https://i.pravatar.cc/300',
                            initials: 'TS',
                            fullname: 'Scottie Pippen',
                            avatarColorType: 'bg-component-background-avatar-random-green',
                        },
                        {
                            photo: 'https://i.pravatar.cc/300',
                            initials: 'TS',
                            fullname: 'Ron Harper',
                            avatarColorType: 'bg-component-background-avatar-random-green',
                        },
                        {
                            photo: 'https://i.pravatar.cc/300',
                            initials: 'TS',
                            fullname: 'Tony Kukoc',
                            avatarColorType: 'bg-component-background-avatar-random-green',
                        },
                        {
                            photo: 'https://i.pravatar.cc/300',
                            initials: 'TS',
                            fullname: 'Dennis Rodman',
                            avatarColorType: 'bg-component-background-avatar-random-green',
                        },
                        {
                            photo: 'https://i.pravatar.cc/300',
                            initials: 'TS',
                            fullname: 'Steve Kerr',
                            avatarColorType: 'bg-component-background-avatar-random-green',
                        },
                    ]"
                />

                <CompassMultiAvatar
                    size="extra-small"
                    :avatars="[
                        {
                            initials: 'xx',
                            fullname: 'Michael Jordan',
                            avatarColorType: 'bg-component-background-avatar-random-pink',
                            stateBadge: 'removed',
                        },
                        {
                            initials: 'TS',
                            fullname: 'Scottie Pippen',
                            avatarColorType: 'bg-component-background-avatar-random-green',
                        },
                    ]"
                />
            </div>

            <!-- *********** -->
            <!-- NUMBERINPUT -->
            <!-- *********** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassNumberInput :</div>
            <div class="container tw-flex-col">
                <CompassNumberInput
                    :model-value="numberInput1"
                    :min="0"
                    :max="0"
                    @change="(val) => (numberInput1 = val)"
                />
                <CompassNumberInput
                    :model-value="numberInput2"
                    :min="-10"
                    :max="10"
                    :step="10"
                    size="large"
                    :disabled="false"
                    :error="false"
                    placeholder="0"
                    @change="(val) => (numberInput2 = val)"
                />
                <CompassNumberInput
                    :model-value="numberInput3"
                    disabled
                    @change="(val) => (numberInput3 = val)"
                />
                <CompassNumberInput
                    :model-value="numberInput4"
                    size="small"
                    error
                    @change="(val) => (numberInput4 = val)"
                />
            </div>

            <!-- ****** -->
            <!-- OBJECT -->
            <!-- ****** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassObject :</div>
            <div class="container">
                <CompassObject object="accounting" label="I'm an object" caption="I'm a caption" />
                <CompassObject
                    label="I'm an object"
                    caption="I'm a caption"
                    size="extra-large"
                    type="removed"
                />
                <CompassObject object="payment" size="extra-small" />
            </div>

            <!-- ***** -->
            <!-- PANEL -->
            <!-- ***** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassPanel :</div>
            <div class="container tw-flex-col">
                <CompassButton
                    label="Open Panel 1 (small + no overflow)"
                    @click="openPanelOne = true"
                ></CompassButton>
                <CompassPanel
                    v-model="openPanelOne"
                    size="small"
                    title="Panel 1 Title qui est finalement assez long et va probablement sur une deuxième ligne parce que bon il faut voir ce que ça donne quand même"
                    :primary-action="{
                        label: 'Placeholder',
                        action: () => handleLog('primaryAction clicked'),
                    }"
                    :secondary-actions="[
                        {
                            label: 'Placeholder',
                            action: () => handleLog('secondaryAction1 clicked'),
                        },
                        {
                            label: 'Placeholder',
                            action: () => handleLog('secondaryAction2 clicked'),
                        },
                    ]"
                    @opened="handleLog('panel 1 is open')"
                    @closed="handleLog('panel 1 is closed')"
                >
                    <p v-for="(_, index) in 5" :key="`panel-content-${index}`" style="margin: 0px">
                        Panel Content
                    </p>
                </CompassPanel>

                <CompassButton
                    label="Open Panel 2 (large + overflow)"
                    @click="openPanelTwo = true"
                ></CompassButton>
                <CompassPanel
                    v-model="openPanelTwo"
                    size="large"
                    title="Panel 1 Title"
                    :primary-action="{
                        label: 'Placeholder',
                        action: () => handleLog('primaryAction clicked'),
                    }"
                    :secondary-actions="[
                        {
                            label: 'Placeholder',
                            action: () => handleLog('secondaryAction1 clicked'),
                        },
                        {
                            label: 'Placeholder',
                            action: () => handleLog('secondaryAction2 clicked'),
                        },
                    ]"
                    @opened="handleLog('panel 2 is open')"
                    @closed="handleLog('panel 2 is closed')"
                >
                    <p v-for="(_, index) in 70" :key="`panel-content-${index}`" style="margin: 0px">
                        Panel Content
                    </p>
                </CompassPanel>
            </div>

            <!-- ******** -->
            <!-- PASSWORD -->
            <!-- ******** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassPassword :</div>
            <div class="container">
                <CompassPassword v-model="passwordValue" show-text="Voir" hide-text="Hide" />
                <CompassPassword
                    v-model="passwordValue2"
                    show-text="Show"
                    hide-text="Masquer"
                    :rules="passwordRules"
                    size="large"
                    :disabled="true"
                    @input="handleInput($event)"
                    @blur="handleBlur($event)"
                    @focus="handleFocus($event)"
                    @change="handleChange($event)"
                />
            </div>

            <!-- *********** -->
            <!-- PROGRESSBAR -->
            <!-- *********** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassProgressBar :</div>
            <div class="container">
                <CompassProgressBar :state="44" />
                <CompassProgressBar :state="46" />
                <CompassProgressBar :state="84" />
                <CompassProgressBar :state="progress" caption="15 jours restants" />
                <CompassProgressBar :state="100" caption="2 jours restants" />
                <CompassProgressBar :state="66" type="colored" caption="2 jours restants" />
            </div>

            <!-- ****** -->
            <!-- RADIO -->
            <!-- ****** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassRadio :</div>
            <div class="container tw-flex-col">
                <div class="tw-flex tw-flex-col tw-items-start tw-gap-2">
                    <CompassRadio model-value="modelChecked1" />
                    <CompassRadio model-value="modelChecked2 checked" checked />
                    <CompassRadio model-value="modelChecked3 small" size="small" />
                    <CompassRadio
                        model-value="modelChecked4 large disabled"
                        size="large"
                        disabled
                    />
                    <CompassRadio model-value="modelChecked5 error" error />
                </div>
            </div>

            <!-- ************* -->
            <!-- RADIOGROUP -->
            <!-- ************* -->
            <div class="tw-align-self-start typographies-heading-h1">CompassRadioGroup :</div>
            <div class="container tw-flex-col">
                <div class="tw-flex tw-flex-col tw-items-start tw-gap-4">
                    <CompassRadioGroup
                        v-model="radioGroupModel"
                        label="RadioGroup horizontal medium"
                        direction="horizontal"
                        size="medium"
                    >
                        <CompassRadio model-value="small" size="small" />
                        <CompassRadio model-value="medium" size="medium" />
                        <CompassRadio model-value="large" size="large" />
                    </CompassRadioGroup>
                    <CompassRadioGroup
                        v-model="radioGroupModel2"
                        label="RadioGroup vertical small"
                        direction="vertical"
                        size="small"
                    >
                        <CompassRadio model-value="MyValue" size="small" />
                        <CompassRadio model-value="MyValue2" size="medium" disabled />
                        <CompassRadio model-value="MyValue3" size="large" error />
                    </CompassRadioGroup>
                    <CompassRadioGroup
                        v-model="radioGroupModel3"
                        label="RadioGroup horizontal large"
                        direction="horizontal"
                        size="large"
                    >
                        <CompassRadio model-value="MyValue small" size="small" />
                        <CompassRadio model-value="MyValue2 medium checked" size="medium" checked />
                        <CompassRadio model-value="MyValue3 large" size="large" />
                    </CompassRadioGroup>
                </div>
            </div>

            <!-- ************* -->
            <!-- TOGGLEBUTTON -->
            <!-- ************* -->
            <div class="tw-align-self-start typographies-heading-h1">CompassToggleButton :</div>
            <div class="container tw-flex-col">
                <div class="tw-flex tw-flex-row tw-items-start tw-gap-4">
                    <CompassToggleButton value="Medium 1" icon="heart-fill" />
                    <CompassToggleButton value="Medium 2" />
                    <CompassToggleButton value="Medium 3" disabled />
                    <CompassToggleButton value="Medium 4" show-dot />
                    <CompassToggleButton value="Medium 5" disabled show-dot />
                    <CompassToggleButton value="Medium 6" :badge="2" />
                    <CompassToggleButton value="Medium 7" :badge="2" disabled />
                    <CompassToggleButton value="Medium 8" :badge="2" disabled show-dot />
                </div>
                <div class="tw-flex tw-flex-row tw-items-start tw-gap-4">
                    <CompassToggleButton value="Large 1" size="large" icon="heart-fill" />
                    <CompassToggleButton value="Large 2" size="large" />
                    <CompassToggleButton value="Large 3" size="large" disabled />
                    <CompassToggleButton value="Large 4" size="large" show-dot />
                    <CompassToggleButton value="Large 5" size="large" disabled show-dot />
                    <CompassToggleButton value="Large 6" size="large" :badge="2" />
                    <CompassToggleButton value="Large 7" size="large" :badge="2" disabled />
                    <CompassToggleButton
                        value="Large 8"
                        size="large"
                        :badge="2"
                        disabled
                        show-dot
                    />
                </div>
            </div>

            <!-- ************* -->
            <!-- TOGGLEBUTTONGROUP -->
            <!-- ************* -->
            <div class="tw-align-self-start typographies-heading-h1">
                CompassToggleButtonGroup :
            </div>
            <div class="container tw-flex-col">
                <div class="tw-flex tw-flex-row tw-items-start tw-gap-4">
                    <CompassToggleButtonGroup v-model="toggleGroup1">
                        <CompassToggleButton value="Medium 1" icon="heart-fill" />
                        <CompassToggleButton value="Medium 2" />
                        <CompassToggleButton value="Medium 3" disabled />
                        <CompassToggleButton value="Medium 4" show-dot />
                        <CompassToggleButton value="Medium 5" disabled show-dot />
                        <CompassToggleButton value="Medium 6" :badge="2" />
                        <CompassToggleButton value="Medium 7" :badge="2" disabled />
                        <CompassToggleButton value="Medium 8" :badge="2" disabled show-dot />
                    </CompassToggleButtonGroup>
                </div>
                <div class="tw-flex tw-flex-row tw-items-start tw-gap-4">
                    <CompassToggleButtonGroup
                        v-model="toggleGroup2"
                        value="Large 4"
                        size="large"
                        :exclusive="true"
                    >
                        <CompassToggleButton value="Large 1" icon="heart-fill" />
                        <CompassToggleButton value="Large 2" />
                        <CompassToggleButton value="Large 34" disabled />
                        <CompassToggleButton value="Large 4" show-dot />
                        <CompassToggleButton value="Large 5" disabled show-dot />
                        <CompassToggleButton value="Large 6" :badge="2" />
                        <CompassToggleButton value="Large 7" :badge="2" disabled />
                        <CompassToggleButton value="Large 8" :badge="2" disabled show-dot />
                    </CompassToggleButtonGroup>
                </div>
                <div class="tw-flex tw-flex-row tw-items-start tw-gap-4">
                    <CompassToggleButtonGroup
                        v-model="toggleGroup3"
                        value="Large 4"
                        size="large"
                        disabled
                        :exclusive="true"
                    >
                        <CompassToggleButton value="Large 1" icon="heart-fill" />
                        <CompassToggleButton value="Large 2" />
                        <CompassToggleButton value="Large 36" disabled />
                        <CompassToggleButton value="Large 4" show-dot />
                        <CompassToggleButton value="Large 5" disabled show-dot />
                        <CompassToggleButton value="Large 6" :badge="2" />
                        <CompassToggleButton value="Large 7" :badge="2" disabled />
                        <CompassToggleButton value="Large 8" :badge="2" disabled show-dot />
                    </CompassToggleButtonGroup>
                </div>
            </div>

            <!-- ****** -->
            <!-- SELECT -->
            <!-- ****** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassSelect :</div>
            <!-- <div class="container">
                <CompassSelect
                    v-model="selectModel"
                    placeholder="Hello there"
                    prefix-icon="heart"
                    size="large"
                    menu-class="testNeil"
                    @blur="handleBlur"
                    @focus="handleFocus"
                >
                    <CompassDropdownSelectOption
                        v-for="(_, index) in 220"
                        :key="index"
                        v-bind="{ label: `My label ${index}`, value: `option-${index}` }"
                    >
                        Option content
                    </CompassDropdownSelectOption>
                </CompassSelect>
                <CompassSelect
                    v-model="selectModel4"
                    placeholder="Link at the end of options"
                    size="large"
                    :actions="[
                        { label: 'Click me', callback: handleClick },
                        { label: 'I am disabled uwu', callback: handleClick, disabled: true },
                    ]"
                >
                    <CompassDropdownSelectOption
                        v-for="option in selectOptions"
                        :key="option.value"
                        v-bind="option"
                    />
                </CompassSelect>
                <CompassSelect
                    v-model="selectModel6"
                    placeholder="No option but link"
                    size="large"
                    :actions="[{ label: 'Click me', callback: handleClick }]"
                >
                </CompassSelect>
                <CompassSelect v-model="selectModel7" placeholder="no options"></CompassSelect>
                <CompassSelect
                    v-model="selectModel2"
                    placeholder="General Kenobi"
                    @blur="handleBlur"
                    @focus="handleFocus"
                >
                    <CompassDropdownSelectOption
                        v-for="option in selectOptions"
                        :key="option.value"
                        v-bind="option"
                    />
                </CompassSelect>
                <CompassSelect
                    v-model="selectModel3"
                    size="small"
                    @blur="handleBlur"
                    @focus="handleFocus"
                >
                    <CompassDropdownSelectOption
                        v-for="option in selectOptions"
                        :key="option.value"
                        v-bind="option"
                    />
                </CompassSelect>
            </div>

            <div class="container">
                <CompassSelect
                    v-model="selectModel5"
                    size="large"
                    @blur="handleBlur"
                    @focus="handleFocus"
                >
                    <CompassOptionGroup
                        v-for="group in selectGroupOptions"
                        :key="group.label"
                        :label="group.label"
                    >
                        <CompassDropdownSelectOption
                            v-for="item in group.options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </CompassDropdownSelectOption>
                    </CompassOptionGroup>
                </CompassSelect>
            </div> -->

            <!-- <CompassFormItem
                :error="isErrorSelectMultiple ? 'Aucun choix' : ''"
                label=""
                class="tw-m-auto tw-w-[150px]"
            >
                <CompassSelect
                    v-model="selectModelMultiple"
                    :multiple="true"
                    :filterable="true"
                    :error="isErrorSelectMultiple"
                    size="medium"
                    :actions="[
                        { label: 'Click me', callback: handleClick },
                        { label: 'I am disabled uwu', callback: handleClick, disabled: true },
                    ]"
                >
                    <CompassDropdownSelectOption
                        v-for="option in selectOptionsMultiple"
                        :key="option.value"
                        v-bind="option"
                    />
                </CompassSelect>
            </CompassFormItem> -->
            <!-- <CompassSelect
                v-model="selectModelMultiple"
                :multiple="true"
                :error="isErrorSelectMultiple"
                :multiple-limite="2"
                :disabled="true"
                class="tw-m-auto tw-w-[150px]"
            >
                <CompassDropdownSelectOption
                    v-for="option in selectOptionsMultiple"
                    :key="option.value"
                    v-bind="option"
                />
            </CompassSelect> -->

            <div class="container">
                <p>Filterable</p>
                <!-- <CompassSelect
                    v-model="selectModel"
                    placeholder="Hello there"
                    prefix-icon="heart"
                    filterable
                    size="large"
                >
                    <CompassDropdownSelectOption
                        v-for="(_, index) in 200"
                        :key="index"
                        v-bind="{ label: `My label ${index}`, value: `option-${index}` }"
                    >
                        Option content
                    </CompassDropdownSelectOption>
                </CompassSelect> -->
            </div>

            <!-- *************** -->
            <!-- SIDE NAVIGATION -->
            <!-- *************** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassSideNav :</div>
            <div class="container">
                <CompassSideNav
                    :menu-items="menuItems"
                    @open="handleSideNavOpen"
                    @select="handleSideNavSelect"
                />
            </div>

            <!-- ************ -->
            <!-- SPLIT BUTTON -->
            <!-- ************ -->
            <div class="tw-align-self-start typographies-heading-h1">CompassSplitButton :</div>
            <div class="black container">
                <CompassSplitButton
                    size="small"
                    type="primary"
                    label="Placeholder"
                    @clickOnLabel="handleClick"
                    @clickOnArrow="handleClick"
                />
                <CompassSplitButton size="small" type="primary" label="Placeholder" disabled />
                <CompassSplitButton size="medium" type="secondary" label="Placeholder" />
                <CompassSplitButton size="large" type="secondary-contrast" label="Placeholder" />
            </div>

            <!-- ****** -->
            <!-- SWITCH -->
            <!-- ****** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassSwitch :</div>
            <div class="container tw-flex-col">
                <CompassSwitch v-model="switchModel" size="large" />
                <CompassSwitch
                    v-model="switchModel2"
                    size="small"
                    active-value="bonjour"
                    inactive-value="coucou"
                    label="Label pour Switch 2"
                />
                <CompassSwitch
                    v-model="switchModel3"
                    size="medium"
                    :active-value="2"
                    inactive-value="fdgdf"
                    label="Label pour Switch 3"
                    disabled
                    orientation="right"
                />
                <CompassSwitch
                    v-model="switchModel3"
                    size="medium"
                    :active-value="2"
                    inactive-value="fdgdf"
                    label="Label pour Switch 3"
                    disabled
                    orientation="left"
                />
                <CompassSwitch
                    v-model="switchModel4"
                    size="large"
                    active-value="perroquet"
                    inactive-value="perruche"
                    label="Label pour Switch 4"
                />
            </div>

            <!-- ***** -->
            <!-- TABLE -->
            <!-- ***** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassTable :</div>
            <div class="container tw-flex-col">
                <CompassTable
                    style="width: 1050px; height: 480px"
                    :columns="[
                        {
                            name: 'active',
                            label: 'Actif',
                        },
                        {
                            name: 'firstname',
                            label: 'Prénom(s)',
                            fixed: true,
                            width: 297,
                        },
                        { name: 'name', label: 'Nom', fixed: true, sortable: true, width: 155 },
                        { name: 'age', label: 'Age', sortable: true, fixed: true, width: 90 },
                        {
                            name: 'job',
                            label: 'emploi',
                            sortable: false,
                        },
                        { name: 'address', label: 'Adresse', fixed: false },
                        { name: 'city', label: 'Ville', sortalbe: true },
                        { name: 'postalCode', label: 'Code postal', width: 150 },
                        { name: 'phone', label: 'Téléphone', width: 100 },
                        { name: 'email', label: 'Adresse éléctronique', sortable: true },
                        { name: 'fax', label: 'Fax' },
                    ]"
                    :rows="[
                        {
                            age: '32',
                            active: {
                                component: 'CompassRadio',
                                caption: 'component exemple',
                                props: {
                                    modelValue: true,
                                    label: 'exemple',
                                    type: 'secondary',
                                },
                            },
                            name: 'ABC',
                            subrowAction: null,
                            firstname: 'empty name + fixed subrow',
                            phone: '0412345678',
                            selectable: true,
                            expandable: true,
                            fixSubrow: true,
                            subrow: 'Ceci est un subrow qui passe par un slot, et est géré par data rows',
                        },
                        {
                            age: '12',
                            subrowAction: null,
                            name: {
                                component: 'CompassButton',
                                props: { label: 'button' },
                            },
                            firstname: 'cpmponent name',
                            phone: '0412345678',
                            selectable: true,
                            expandable: true,
                            job: {
                                component: 'CompassObject',
                                caption: 'ceci est un Objet',
                                props: {
                                    caption: 'caption',
                                    label: 'Poste',
                                },
                            },
                            subrow: {
                                component: 'CompassObject',
                                caption: 'ceci est un Objet',
                                props: {
                                    caption: 'caption',
                                    label: 'Poste',
                                },
                            },
                        },
                        {
                            name: 'subrow vide',
                            job: 'Data scientist',
                            email: 'Mariah@company.fr',
                            firstname: 'ABC',
                            showSubrow: true,
                            subrow: '100.23',
                        },

                        { name: 'ZZZ', firstname: 'Lewis', job: 'Chef de projet' },
                        {
                            age: '82',
                            subrowAction: null,
                            name: '',
                            firstname: 'empty name',
                            phone: '0412345678',
                            selectable: true,
                            expandable: true,
                            subrow: 'Ceci est un subrow qui passe par un slot, et est géré par data rows',
                        },
                        {
                            age: '39',
                            subrowAction: null,
                            firstname: 'table component - no name',
                            phone: '0412345678',
                            selectable: true,
                            expandable: true,
                            subrow: {
                                component: 'CompassTable',
                                props: {
                                    columns: [
                                        { name: 'name', label: 'Nom' },
                                        { name: 'firstname', label: 'Prénom' },
                                        { name: 'location', label: 'Adresse Principale' },
                                        { name: 'other', label: 'Autre' },
                                    ],
                                    rows: [
                                        {
                                            name: 'Parker',
                                            firstname: 'Peter',
                                            location: 'Queens - New York',
                                            other: '',
                                        },
                                        {
                                            name: 'Morales',
                                            firstname: 'Miles',
                                            location: 'Bronx',
                                            other: 'Too young to be an hero',
                                        },
                                        {
                                            name: 'Stacy',
                                            firstname: 'Gwen',
                                            location: '',
                                            other: 'Sometimes called Spider-gwen',
                                        },
                                        {
                                            name: '',
                                            firstname: '',
                                            location: '',
                                            other: 'No one know the true identity of Spider-pig',
                                        },
                                        {
                                            name: 'Parker',
                                            firstname: 'Peter',
                                            location: '',
                                            other: 'Called Spider-man noir, dub by Nicolas Cage',
                                        },
                                    ],
                                },
                            },
                        },
                        {
                            age: '31',
                            subrowAction: null,
                            expandable: true,
                            firstname: 'no name',
                            subrow: {
                                component: 'CompassProgressBar',
                                props: { state: 40, caption: 'caption', type: 'default' },
                            },
                        },
                        {
                            age: '32.4',
                            subrowAction: null,
                            name: '',
                            firstname: 'empty name',
                            phone: '0412345678',
                            selectable: true,
                            expandable: true,
                            subrow: 'Ceci est un subrow qui passe par un slot, et est géré par data rows',
                        },
                        {
                            name: 'Bernadinet',
                            age: '42.99',
                            job: 'Developer',
                            subrowAction: null,
                            subrowAction: null,
                            city: 'La Rochelle',
                            fax: '04.12.34.56.78',
                            phone: '01.12.34.56.78',
                        },
                        { name: 'Harmon', firstname: 'Dorothée', age: 36, job: 'Designer' },
                        {
                            name: 'Ritthe',
                            firstname: 'Pierre',
                            age: 36,
                            job: 'Testeur',
                        },
                    ]"
                    size="medium"
                    :loading="false"
                    :actions="[
                        {
                            label: 'action_1',
                            name: 'action-one',
                            callback: handleClick,
                            disabled: false,
                        },
                        {
                            label: 'action_2',
                            name: 'action-two',
                            callback: handleClick,
                            disabled: false,
                        },
                        {
                            label: 'action_3',
                            name: 'action-three',
                            callback: handleClick,
                            disabled: true,
                        },
                    ]"
                    fix-action
                    fix-header-row
                    fix-selectable-columns
                    fix-expandable-columns
                    large-rows
                    expandable
                    selectable
                    @selectionChange="handleTableSelectionChange"
                >
                    <template #footer>
                        <span>Si tu supprimes ce texte du slot footer, je disparais</span>
                    </template>
                </CompassTable>
                <CompassTable
                    style="width: 100%"
                    :columns="[
                        { name: 'firstname', label: 'Prénom' },
                        { name: 'name', label: 'Nom' },
                    ]"
                    :rows="[
                        { name: 'Wermont', firstname: 'Kévin' },
                        { name: 'Cohett', firstname: 'Marie' },
                        { name: 'Marais', firstname: 'Ludwing' },
                        {
                            name: 'Mgondu',
                            firstname: 'Aki',
                            subrow: {
                                component: 'CompassTable',
                                props: {
                                    expandable: true,
                                    columns: [
                                        { name: 'firstname', label: 'Prénom' },
                                        { name: 'name', label: 'Nom' },
                                    ],
                                    rows: [
                                        { name: 'Wermont', firstname: 'Kévin' },
                                        { name: 'Cohett', firstname: 'Marie' },
                                        { name: 'Marais', firstname: 'Ludwing' },
                                        {
                                            name: 'Mgondu',
                                            firstname: 'Aki',
                                        },
                                    ],
                                },
                            },
                        },
                    ]"
                    :loading="false"
                    expandable
                >
                </CompassTable>
            </div>

            <!-- **** -->
            <!-- TABS -->
            <!-- **** -->
            <div class="align-self-start typographies-heading-h1">CompassTabs :</div>
            <CompassTabs v-model="tabModel">
                <CompassTabPane label="Un" name="one" :icon="'pin-fill'"
                    >Une Belle histoire</CompassTabPane
                >
                <CompassTabPane label="Deux" name="two">commence toujours par</CompassTabPane>
                <CompassTabPane label="Trois" name="three">un développeur</CompassTabPane>
                <CompassTabPane label="Quatre" name="four" :badge="4">et son chien</CompassTabPane>
                <CompassTabPane label="Cinq" name="five" :badge="0">Fin</CompassTabPane>
                <CompassTabPane
                    label="Six"
                    name="six"
                    :badge="3"
                    :flag="{ label: 'beta', beta: true }"
                    >Vraie fin</CompassTabPane
                >
                <CompassTabPane label="Secret" name="secret" :disabled="true" icon="heart"
                    >Plus qu'une étape avant de kiffer: suG-c_i2fBQ</CompassTabPane
                >
            </CompassTabs>

            <!-- **** -->
            <!-- TAGS -->
            <!-- **** -->
            <div class="align-self-start typographies-heading-h1">CompassTag :</div>
            <div class="container flex-col">
                <CompassTag
                    size="small"
                    :showDot="true"
                    type="colored"
                    color="blue"
                    :showClose="true"
                >
                    Coucou
                </CompassTag>
                <CompassTag :showDot="true" color="red" :showClose="true">Coucou</CompassTag>
                <CompassTag size="large" :showDot="true" color="yellow" :showClose="true"
                    >Coucou</CompassTag
                >
            </div>

            <!-- ******** -->
            <!-- TELINPUT -->
            <!-- ******** -->
            <div class="align-self-start typographies-heading-h1">CompassTelInput :</div>
            <div class="container flex-col">
                <CompassTelInput v-model="phone" :countries="['fr', 'es', 'de', 'us', 'it']" />
            </div>

            <!-- ***** -->
            <!-- TOAST -->
            <!-- ***** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassToast :</div>
            <div class="container">
                <CompassToastHandler></CompassToastHandler>
            </div>
            <CompassButton
                label="Push NEUTRAL Toast (icon + action + close)"
                @click="
                    $pushToast({
                        type: 'neutral',
                        icon: true,
                        text: 'Hey Salut !',
                        action: {
                            text: 'Informations',
                            callback: toastAction,
                        },
                        close: true,
                        timeout: 5000,
                    })
                "
            />
            <CompassButton
                label="Push INFORMATIVE Toast (icon)"
                @click="
                    $pushToast({
                        type: 'informative',
                        icon: true,
                        text: 'Adiou toi !',
                        close: false,
                        timeout: 5000,
                    })
                "
            />
            <CompassButton
                label="Push SUCCESS Toast (icon + text)"
                @click="
                    $pushToast({
                        type: 'success',
                        icon: true,
                        text: 'Hey, coucou',
                        close: false,
                        timeout: 5000,
                    })
                "
            />
            <CompassButton
                label="Push WARNING Toast (text)"
                @click="
                    $pushToast({
                        type: 'warning',
                        icon: false,
                        text: 'Oula, attention !',
                        close: false,
                        timeout: 5000,
                    })
                "
            />
            <CompassButton
                label="Push ERROR Toast (icon, text, action; unique)"
                @click="
                    $pushToast({
                        type: 'error',
                        icon: true,
                        text: 'Aïe, problème !',
                        action: {
                            text: 'Informations',
                            callback: toastAction,
                        },
                        close: false,
                        timeout: 5000,
                        unique: true,
                    })
                "
            />

            <!-- ******** -->
            <!-- TOOLTIPS -->
            <!-- ******** -->
            <div class="tw-align-self-start typographies-heading-h1">CompassTooltip :</div>
            <div class="container">
                <CompassTooltip
                    content="Top center"
                    placement="top"
                    :delay="{ show: 3000, hide: 2000 }"
                >
                    <span>J'ai un tooltip</span>
                </CompassTooltip>
                <CompassTooltip content="Bottom start" placement="bottom-start">
                    <span>J'ai un tooltip qui pose souci</span>
                </CompassTooltip>
                <CompassTooltip content="" theme="light">
                    <template #content>
                        <span>Voici mon super contenu<br />sur 2 lignes</span>
                    </template>
                    J'ai un super tooltip blanc<br />
                </CompassTooltip>
                <CompassTooltip content="" :arrow="false">
                    <template #content>
                        <span>Le contenu avec tooltip</span>
                    </template>
                    Je n'ai pas de flèche sur mon tooltip
                </CompassTooltip>
                <CompassTooltip content="" placement="bottom-start" :arrow="false" disabled>
                    <template #content>
                        <span>Le contenu avec tooltip</span>
                    </template>
                    Mon tooltip n'est pas visible
                </CompassTooltip>
            </div>
        </div>
    </div>
</template>

<script>
import RichText from 'vcomponents/richtext/RichText.vue';
/* eslint-disable no-console, no-control-regex */
export default {
    name: 'App',
    components: {
        RichText,
    },
    data() {
        return {
            editorContent: `
                <p>Contenu dans Compass2</p>
                <table>
                    <tbody>
                        <tr>
                        <th>Name</th>
                        <th colspan="3">Description</th>
                        </tr>
                        <tr>
                        <td>Cyndi Lauper</td>
                        <td>Singer</td>
                        <td>Songwriter</td>
                        <td>Actress</td>
                        </tr>
                    </tbody>
                </table>
            `,
            formItemRichText: {
                label: this.$l10n.__('RichText'),
                // size ? all adapt for always medium
                // info: 'caption info',
                // error: 'caption error',
                // disabled ? use disabled props on RichText
                // required: true,
            },
            optionsRichText: [
                'Heading',
                'Size',
                'Bold',
                'Italic',
                'Underline',
                'Strike',
                'Blockquote',
                // 'Color',
                // 'Highlight',
                'TextAlign',
                'BulletList',
                'OrderedList',
                // 'Table',
                'CodeBlock',
                'Unformat',
                ['More', 'Strike', 'Blockquote'], // Use if no space for all
                'Divider',
                'Link',
                'Image',
                // 'Attachment',
                // 'Emoji',
                // 'AI',
                ['Specific', 'CustomTags'], // Use if no space for all & specific options
                'Mention',
                'CustomTags',
                'CustomTagsAndFields',
            ],
            neil: 'coucou\nsdfsdfds',
            checkboxGroupModel: ['small', 'medium'],
            checkboxGroupModel2: [],
            radioGroupModel: 'small',
            radioGroupModel2: 'MyValue2',
            radioGroupModel3: 'MyValue3 large',
            openFeatureModal: false,
            openModalOne: false,
            openModalTwo: false,
            openModalThree: false,
            openPanelOne: false,
            openPanelTwo: false,
            inputModel: 'data',
            inputModel2: 'data2',
            inputModel3: 'data3',
            inputModel4: 'textarea',
            switchModel: true,
            switchModel2: 'bonjour',
            switchModel3: 2,
            switchModel4: 'perruche',
            hasError: false,
            isDisabled: false,
            selectModel: 'coucou',
            selectModel2: 1,
            selectModel3: '',
            selectModel4: '',
            selectModel5: '',
            selectModel6: '',
            selectModel7: '',
            selectModelMultiple: ['name', 'id'],
            selectOptionsMultiple: [
                { value: 'name', label: 'nom' },
                { value: 'id', label: 'identifiant', type: 'checkbox' },
                { value: 'email', label: 'Email société', disabled: true, type: 'checkbox' },
                {
                    label: 'Number One',
                    value: 1,
                    counter: 99999,
                    caption: 'poo',
                    icon: 'heart',
                },
            ],
            selectOptions: [
                {
                    label: 'Option avec image',
                    value: 'image',
                    image: 'https://assets-global.website-files.com/6058a411307dccf59c654f37/6058bc2978b0d14b8c663f9d_sellsy-logo.svg',
                },
                {
                    label: 'Number One',
                    value: 1,
                    counter: 99999,
                    caption: 'poo',
                    icon: 'heart',
                },
                {
                    label: 'Olivier Bertrand',
                    value: 'olivierbertrand',
                    type: 'avatar',
                    avatar: {
                        initials: 'OB',
                        state: 'default',
                    },
                },
                {
                    label: "I'm disabled",
                    value: 'disabled',
                    disabled: true,
                },
                {
                    label: 'Option 4',
                    value: 'four',
                    caption: 'country',
                },
                {
                    label: 'Option 4.1',
                    value: 'four1',
                    caption: 'country',
                },
                {
                    label: 'Option 4.2',
                    value: 'four2',
                    caption: 'country',
                },
                {
                    label: 'Option 4.3',
                    value: 'four3',
                    caption: 'country',
                },
                {
                    label: 'Option 4.4',
                    value: 'four4',
                    caption: 'country',
                },
                {
                    label: 'Option 4.5',
                    value: 'four5',
                    caption: 'country',
                },

                {
                    label: 'For Thomas',
                    value: true,
                },
            ],
            selectGroupOptions: [
                {
                    label: 'Popular cities',
                    options: [
                        {
                            value: 'Shanghai',
                            label: 'Shanghai',
                        },
                        {
                            value: 'Beijing',
                            label: 'Beijing',
                        },
                    ],
                },
                {
                    options: [
                        {
                            value: 'Chengdu',
                            label: 'Chengdu',
                        },
                        {
                            value: 'Shenzhen',
                            label: 'Shenzhen',
                        },
                        {
                            value: 'Guangzhou',
                            label: 'Guangzhou',
                        },
                        {
                            value: 'Dalian',
                            label: 'Dalian',
                        },
                    ],
                },
            ],
            menuItems: [
                {
                    label: 'I have children',
                    subItems: [
                        {
                            label: 'I have the same structure',
                            route: 'my.super.route',
                            active: true,
                        },
                        {
                            label: "I have the same structure but I'm disabled",
                            route: 'my.super.route',
                            disabled: true,
                        },
                        {
                            label: 'I go to the coucou page',
                            path: '/coucou',
                        },
                        {
                            label: 'I go to google in a new tab',
                            path: 'https://www.google.com',
                            blank: true,
                        },
                    ],
                },
                {
                    label: 'I go to google on the same page',
                    path: 'https://www.google.com',
                },
                {
                    label: "I'm disabled",
                    disabled: true,
                    action: () => console.log('coucou from disabled'),
                },
                {
                    label: 'I have an action',
                    action: () => console.log('coucou'),
                },
                {
                    label: 'I have children 2',
                    subItems: [
                        {
                            label: 'I have the same structure 2',
                            route: 'my.super.route',
                        },
                        {
                            label: 'I have the same structure 2',
                            route: 'my.super.route',
                        },
                    ],
                },
                {
                    label: 'I have children 3',
                    subItems: [
                        {
                            label: 'I have the same structure 3',
                            route: 'my.super.route',
                        },
                        {
                            label: 'I have the same structure 3',
                            route: 'my.super.route',
                        },
                    ],
                },
            ],
            tabModel: 'one',
            toggleGroup1: ['Medium 1'],
            toggleGroup2: 'Large 2',
            toggleGroup3: 'Large 2',
            passwordValue: 'sdfdsf',
            passwordValue2: '',
            passwordRules: [
                {
                    label: '1 chiffre',
                    isValid: true,
                },
                {
                    label: '14000 caractères',
                    isValid: false,
                },
                {
                    label: 'La date',
                    isValid: false,
                },
            ],
            numberInput1: 0,
            numberInput2: 0,
            numberInput3: 0,
            numberInput4: 0,
            progress: 0,
            phone: '',
            results: [],
            loading: false,
            hasMoreResults: false,
        };
    },
    computed: {
        isErrorSelectMultiple() {
            return this.selectModelMultiple.length === 0;
        },
    },
    methods: {
        handleLog(arg) {
            console.log(arg);
        },
        toastAction() {
            console.log('coucou');
        },
        handleBeforeCloseDialog() {
            const res = confirm('Êtes-vous sûr de vouloir fermer la modal ?');
            if (res) {
                this.openModalTwo = false;
            }
        },
        handleClickValue(value) {
            console.log('clicked +', value);
        },
        handleClick() {
            console.log('clicked');
        },
        handleBlur($event) {
            console.log('BLUR', $event);
        },
        handleFocus($event) {
            console.log('FOCUS', $event);
        },
        handleInput($event) {
            console.log('INPUT', $event);
        },
        handleChange($event) {
            console.log('CHANGE', $event);
        },
        setError() {
            this.hasError = !this.hasError;
        },
        setDisabled() {
            this.isDisabled = !this.isDisabled;
        },
        handleValue($event) {
            console.log('Value depuis App.vue :', $event.target.value);
        },
        randomColorGen() {
            const arrayToRandomize = ['green', 'yellow', 'pink'];
            const resultRandom = Math.floor(Math.random() * arrayToRandomize.length);
            if (resultRandom === 1) {
                return 'green';
            } else if (resultRandom === 2) {
                return 'yellow';
            } else {
                return 'pink';
            }
        },
        handleSideNavOpen(item) {
            console.log(`opened ${item.label}`);
        },
        handleSideNavSelect(item) {
            console.log(`selected ${item.label}`);
        },
        handleVisibleChange() {
            console.log('visibility-change');
        },
        handleOpen() {
            console.log('open');
        },
        handleClose() {
            console.log('close');
        },
        handleTableSelectionChange(items) {
            console.log('selected list :', items);
        },
        handleAutoCompleteFetchResults(query) {
            if (query === 'no results') {
                this.results = [];
                return;
            }
            if (query === 'loading') {
                this.loading = true;
                return;
            }
            this.results = [];
            this.loading = true;
            setTimeout(() => {
                for (let index = 0; index < 10; index++) {
                    this.results.push({
                        id: index,
                        value: index,
                        label: `${query} ${index}`,
                        disabled: false,
                    });
                }
                this.hasMoreResults = true;
                this.loading = false;
            }, 1000);
        },
        handleAutoCompleteFetchMoreResults() {
            setTimeout(() => {
                for (let index = 0; index < 10; index++) {
                    this.results.push({
                        id: index,
                        value: index,
                        label: `more results ${index}`,
                        disabled: false,
                    });
                }
                this.hasMoreResults = false;
            }, 1000);
        },
        handleAutoCompleteChange(value) {
            console.log('autocomplete selection :', value);
        },
    },
};
</script>

<style lang="scss" scoped>
.container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
}
.black {
    padding: 10px;
    background-color: black;
}
.context-menu {
    width: 200px;
}

.rich-text.custom-richtext {
    width: 1000px;
}
</style>
